import { Button, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@heroui/react";
import { useModal } from "src/infra/ModalProvider/ModalContext";

export function useConfirm<T = any>({
	onConfirm,
	onCancel,
	title = "are you sure?",
	message = "Please confirm that you want to proceed with this action.",
	confirmText = "approve",
	cancelText = "cancel",
}: {
	onConfirm: (close: () => void, data?: T) => void;
	onCancel?: () => void;
	title?: string;
	message?: string;
	confirmText?: string;
	cancelText?: string;
}) {
	const modal = useModal();

	return (data?: T) => {
		modal.open(() => {
			return (
				<ModalContent>
					{(onClose) => (
						<>
							<ModalHeader className="flex flex-col gap-1">{title}</ModalHeader>
							<ModalBody>{message}</ModalBody>
							<ModalFooter>
								<Button
									color="danger"
									variant="light"
									onPress={() => {
										onClose();
										onCancel?.();
									}}
								>
									{cancelText}
								</Button>
								<Button color="primary" onPress={() => onConfirm(onClose, data)}>
									{confirmText}
								</Button>
							</ModalFooter>
						</>
					)}
				</ModalContent>
			);
		});
	};
}
